export default __webpack_public_path__ + "static/media/trash.86500a8b.svg";